import { MediaType } from "@/modules/common/media/mediaTypes"
import { SessionBlockType } from "@/modules/sessions/sessionDetails/sessionBlockTypes"
import { z } from "zod"

/*
  MediaContentDto is used in:
    * MediasContentDto
*/
export const MediaContentDtoSchema = z
  .object({
    id: z.string().nullable(),
    url: z
      .string()
      .transform((s) => {
        const t = s.trim()
        if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(t)) return t
        return `https://${t}`
      })
      .pipe(z.httpUrl())
      .nullable(),
    awsS3Key: z.string().nullable(),
    filename: z.string().nullable(),
    type: z.enum(MediaType),
    orderIndex: z.number(),
  })
  .meta({ id: "MediaContentDtoSchema" })

/* 
  MediasContentDto is used in:
    * BlockSessionInput
  */
export const MediasContentDtoSchema = z
  .object({
    medias: z.array(MediaContentDtoSchema),
  })
  .meta({ id: "MediasContentDtoSchema" })

/*
  SessionMediaDto is used in:
    * SessionMediasDto
  */
export const SessionMediaDtoSchema = z
  .object({
    id: z.string(),
    url: z
      .string()
      .transform((s) => {
        const t = s.trim()
        if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(t)) return t
        return `https://${t}`
      })
      .pipe(z.httpUrl()),
    type: z.enum(MediaType),
    filename: z.string().nullable(),
  })
  .meta({ id: "SessionMediaDtoSchema" })

/*
SessionMediasDto is used in:
    * SessionBlockDto
*/
export const SessionMediasDtoSchema = z
  .object({
    blockType: z.literal(SessionBlockType.MEDIAS),
    medias: z.array(SessionMediaDtoSchema),
    orderIndex: z.number(),
  })
  .meta({ id: "SessionMediasDtoSchema" })

export type MediaContentDto = z.infer<typeof MediaContentDtoSchema>
export type MediasContentDto = z.infer<typeof MediasContentDtoSchema>
export type SessionMediaDto = z.infer<typeof SessionMediaDtoSchema>
export type SessionMediasDto = z.infer<typeof SessionMediasDtoSchema>
